import { render, staticRenderFns } from "./SupportPanelAlert.vue?vue&type=template&id=60ded35d&scoped=true&"
import script from "./SupportPanelAlert.vue?vue&type=script&lang=ts&"
export * from "./SupportPanelAlert.vue?vue&type=script&lang=ts&"
import style0 from "./SupportPanelAlert.vue?vue&type=style&index=0&id=60ded35d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ded35d",
  null
  
)

export default component.exports